import { createFileRoute } from '@tanstack/react-router'
import { EditConditionPage } from '_/features/pets/ui/pages/edit-condition-page'

const EditConditionRoute = () => {
	const { petId, conditionId } = Route.useParams()
	return <EditConditionPage petId={petId} conditionId={conditionId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/conditions/$conditionId/edit')({
	staticData: { title: 'conditions_edit_title' },
	component: EditConditionRoute,
})
